import { useRef, useState } from 'react'
import { Link } from 'react-router'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'
import image4 from './images/4.jpg'

export const PricingSection: React.FC = () => {
  const [photoIndex, setPhotoIndex] = useState(0)
  const touchStartX = useRef<number | null>(null)

  const images = [image1, image2, image3, image4]

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX
  }
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return
    const diff = touchStartX.current - e.changedTouches[0].clientX
    if (diff > 40) setPhotoIndex((i) => (i + 1) % images.length)
    else if (diff < -40) setPhotoIndex((i) => (i - 1 + images.length) % images.length)
    touchStartX.current = null
  }

  return (
    <section id="pricing" className="pt-10 pb-20 md:pt-14 md:pb-28 px-5">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-medium text-black leading-relaxed">料金プラン</h2>
      </div>

      <div className="mt-12 max-w-4xl mx-auto rounded-2xl border border-gray bg-white overflow-hidden">
        <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-1/2 shrink-0 relative">
            <div className="aspect-square md:aspect-auto md:h-full overflow-hidden" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
              <div className="flex h-full transition-transform duration-300 ease-in-out" style={{ transform: `translateX(-${photoIndex * 100}%)` }}>
                {images.map((src, i) => (
                  <img key={i} src={src} alt="枝もののボリューム感" className="w-full h-full object-cover shrink-0" />
                ))}
              </div>
            </div>

            <button
              onClick={() => setPhotoIndex((i) => (i - 1 + images.length) % images.length)}
              className="absolute left-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/80 flex items-center justify-center shadow-sm hover:bg-white transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M10 12L6 8l4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button
              onClick={() => setPhotoIndex((i) => (i + 1) % images.length)}
              className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/80 flex items-center justify-center shadow-sm hover:bg-white transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5">
              {images.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setPhotoIndex(i)}
                  className={`w-1.5 h-1.5 rounded-full transition-colors ${i === photoIndex ? 'bg-white' : 'bg-white/50'}`}
                />
              ))}
            </div>
          </div>

          <div className="w-full md:w-1/2 p-7 md:p-9 text-center flex flex-col justify-center">
            <div className="flex flex-col items-center gap-2">
              <div className="flex items-baseline gap-2">
                <span className="text-[13px] text-dark-gray shrink-0">1配送あたり</span>
                <span className="text-5xl md:text-6xl font-display font-semibold text-black tracking-tight">3,200</span>
                <span className="text-[22px] text-main font-sans font-semibold">円</span>
              </div>
              <p className="font-display font-medium text-main">
                <span className="text-[12px] font-sans font-semibold">税込</span>
                <span className="text-[22px] ml-1">3,520</span>
                <span className="text-[14px] ml-0.5 font-sans font-semibold">円</span>
              </p>
            </div>

            <div className="mt-3 flex justify-center">
              <div className="inline-flex items-center border border-accent rounded-md overflow-hidden">
                <div className="flex items-center gap-1 bg-accent/20 px-3 py-1.5 text-accent text-[13px] font-bold">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="1" y="3" width="15" height="13" rx="1" />
                    <path d="M16 8h4l3 5v3h-7V8z" />
                    <circle cx="5.5" cy="18.5" r="2.5" />
                    <circle cx="18.5" cy="18.5" r="2.5" />
                  </svg>
                  送料無料
                </div>
                <div className="px-3 py-1.5 text-accent text-[12px]">通常配送料 約1,800円分おトク</div>
              </div>
            </div>

            <div className="mt-6 space-y-3 text-left max-w-xs mx-auto">
              {['旬の枝もの 5本以上', '長さ約80cm', '月1回・月2回から選べる', '違約金なし・いつでも解約OK', '受け取れない時はスキップ可能'].map((item, i) => (
                <ul key={i} className="text-[15px] text-main ml-3.5">
                  <li className="pl-3 list-['—']">{item}</li>
                </ul>
              ))}
            </div>

            <p className="mt-4 text-[12px] text-dark-gray leading-relaxed">
              夏期（6〜9月予定）はクール便 ＋税込330円
              <br />
              ※北海道のみ冬期（12〜3月予定）もクール便配送
            </p>

            <Link
              reloadDocument
              to="/subscription/branch/new"
              className="inline-block mt-7 px-12 py-5 bg-accent text-white text-[14px] font-medium tracking-wide rounded-full hover:opacity-90 transition-opacity"
            >
              定期便を始める
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
